// extracted by mini-css-extract-plugin
export default {"footer":"Loader_footer__Fq9DJ","wrapper":"Loader_wrapper__2YrQT","circle":"Loader_circle__DzuXv","shadow":"Loader_shadow__jvuvI"};